module.exports = "/images/ms.svg?3b948bbee37b40194854bfe2b307a4bc";